$(document).ready(function() {
  $('.info-symptom-improvement').tooltip();
});

